function _0x4d92(_0x2376d0, _0x167ebe) {
  const _0x21589c = _0x2158();
  return _0x4d92 = function (_0x4d924c, _0xdb8786) {
    _0x4d924c = _0x4d924c - 0x133;
    let _0x348bac = _0x21589c[_0x4d924c];
    if (_0x4d92['gUKDvc'] === undefined) {
      var _0x2cc6dd = function (_0x42ee6a) {
        const _0x548ea6 = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';
        let _0x58dc42 = '',
          _0x21f63f = '';
        for (let _0x8f4917 = 0x0, _0x144803, _0x409a79, _0x1a70dc = 0x0; _0x409a79 = _0x42ee6a['charAt'](_0x1a70dc++); ~_0x409a79 && (_0x144803 = _0x8f4917 % 0x4 ? _0x144803 * 0x40 + _0x409a79 : _0x409a79, _0x8f4917++ % 0x4) ? _0x58dc42 += String['fromCharCode'](0xff & _0x144803 >> (-0x2 * _0x8f4917 & 0x6)) : 0x0) {
          _0x409a79 = _0x548ea6['indexOf'](_0x409a79);
        }
        for (let _0x180312 = 0x0, _0x1c0fba = _0x58dc42['length']; _0x180312 < _0x1c0fba; _0x180312++) {
          _0x21f63f += '%' + ('00' + _0x58dc42['charCodeAt'](_0x180312)['toString'](0x10))['slice'](-0x2);
        }
        return decodeURIComponent(_0x21f63f);
      };
      _0x4d92['LtQmWo'] = _0x2cc6dd, _0x2376d0 = arguments, _0x4d92['gUKDvc'] = !![];
    }
    const _0x5c3af7 = _0x21589c[0x0],
      _0x7aa830 = _0x4d924c + _0x5c3af7,
      _0x26f2ee = _0x2376d0[_0x7aa830];
    return !_0x26f2ee ? (_0x348bac = _0x4d92['LtQmWo'](_0x348bac), _0x2376d0[_0x7aa830] = _0x348bac) : _0x348bac = _0x26f2ee, _0x348bac;
  }, _0x4d92(_0x2376d0, _0x167ebe);
}
const _0x5377ad = _0x4d92;
(function (_0xe2a671, _0x55c171) {
  const _0x113beb = _0x4d92,
    _0x147a01 = _0xe2a671();
  while (!![]) {
    try {
      const _0x15d0c2 = -parseInt(_0x113beb(0x16f)) / 0x1 + parseInt(_0x113beb(0x141)) / 0x2 + parseInt(_0x113beb(0x16c)) / 0x3 + -parseInt(_0x113beb(0x1b1)) / 0x4 * (-parseInt(_0x113beb(0x142)) / 0x5) + -parseInt(_0x113beb(0x1d9)) / 0x6 * (parseInt(_0x113beb(0x1b3)) / 0x7) + parseInt(_0x113beb(0x138)) / 0x8 + -parseInt(_0x113beb(0x1ba)) / 0x9;
      if (_0x15d0c2 === _0x55c171) break;else _0x147a01['push'](_0x147a01['shift']());
    } catch (_0x5c1246) {
      _0x147a01['push'](_0x147a01['shift']());
    }
  }
})(_0x2158, 0x516b8);
const GRACE_SUBSCRIPTION_DAYS = 0xa,
  JWT_LICENSE_EVIDENCE_TYPE = _0x5377ad(0x1b5),
  LOG_HEADER = _0x5377ad(0x1d3),
  PUBLIC_KEY = _0x5377ad(0x144),
  logHeader = (_0x19a3db, _0x5e126e) => '[' + _0x19a3db + ']' + ('[' + LOG_HEADER + ']') + (_0x5e126e ? '\x20' + _0x5e126e + ':' : '');
function toNumericDate(_0x262b54) {
  const _0x23775a = _0x5377ad;
  return Math[_0x23775a(0x1c1)](_0x262b54[_0x23775a(0x1db)]() / 0x3e8);
}
function addDays(_0x499b40, _0x3323fe) {
  const _0x59e15e = _0x5377ad,
    _0x25f936 = new Date(_0x499b40 * 0x3e8);
  return _0x25f936[_0x59e15e(0x15b)](_0x25f936[_0x59e15e(0x191)]() + _0x3323fe), toNumericDate(_0x25f936);
}
function getCurrentDate() {
  return toNumericDate(new Date());
}
function daysSinceToday(_0x52b8e4) {
  const _0x74e18e = _0x5377ad,
    _0x250c28 = getCurrentDate() - toNumericDate(_0x52b8e4),
    _0x180f40 = Math[_0x74e18e(0x1c1)](_0x250c28 / (0x18 * 0x3c * 0x3c));
  return _0x180f40;
}
function decodeString(_0xbd2aeb) {
  const _0x1d0c29 = _0x5377ad;
  if (typeof atob === _0x1d0c29(0x19a)) {
    if (_0x1d0c29(0x174) === _0x1d0c29(0x174)) return atob(_0xbd2aeb);else {
      const _0x27851d = _0x45eb19 ^ _0x3e027d;
      return _0x3a5992 = _0x3730b8, _0x27851d;
    }
  }
  if (typeof Buffer === _0x1d0c29(0x19a)) {
    if (_0x1d0c29(0x1d1) !== _0x1d0c29(0x1aa)) return Buffer[_0x1d0c29(0x14b)](_0xbd2aeb, _0x1d0c29(0x1b6))[_0x1d0c29(0x13d)](_0x1d0c29(0x1cd));else {
      var _0x2c92b2, _0x222fc0;
      return _0x5982dc[_0x1d0c29(0x13c)] === _0x234d23[_0x1d0c29(0x1ab)] || ((_0x2c92b2 = _0x6250bd[_0x1d0c29(0x136)]) === null || _0x2c92b2 === void 0x0 ? void 0x0 : _0x2c92b2[_0x1d0c29(0x17e)](_0x48ef7f[_0x1d0c29(0x1ab)])) || ((_0x222fc0 = _0x5264b6[_0x1d0c29(0x158)]) === null || _0x222fc0 === void 0x0 ? void 0x0 : _0x222fc0[_0x1d0c29(0x17e)](_0x318dc8[_0x1d0c29(0x1ab)]));
    }
  }
  throw new Error(_0x1d0c29(0x1c3));
}
function decodeBase64(_0x3ac1da) {
  const _0x530df7 = _0x5377ad,
    _0x589f8e = decodeString(_0x3ac1da),
    _0x4bc848 = new Uint8Array(_0x589f8e[_0x530df7(0x1b2)]);
  for (let _0x4c6a4b = 0x0; _0x4c6a4b < _0x589f8e[_0x530df7(0x1b2)]; _0x4c6a4b++) {
    if (_0x530df7(0x18b) === _0x530df7(0x182)) {
      const _0x54c0ea = _0x2a8377(_0x4e61ea),
        _0xfafbab = new _0x4dd5c5(_0x54c0ea[_0x530df7(0x1b2)]);
      for (let _0x1f8ca1 = 0x0; _0x1f8ca1 < _0x54c0ea[_0x530df7(0x1b2)]; _0x1f8ca1++) {
        _0xfafbab[_0x1f8ca1] = _0x54c0ea[_0x530df7(0x171)](_0x1f8ca1);
      }
      return _0xfafbab;
    } else _0x4bc848[_0x4c6a4b] = _0x589f8e[_0x530df7(0x171)](_0x4c6a4b);
  }
  return _0x4bc848;
}
function decodeBase64Url(_0x348eeb) {
  const _0x12e0f2 = _0x5377ad,
    _0x532041 = _0x348eeb[_0x12e0f2(0x181)](/-/g, '+')[_0x12e0f2(0x181)](/_/g, '/');
  return decodeBase64(_0x532041);
}
function decodeLicenseEvidence(_0x633c41) {
  const _0x50e9cc = _0x5377ad,
    _0x93a1df = _0x633c41[_0x50e9cc(0x186)]('.')[0x1],
    _0x5b1686 = String[_0x50e9cc(0x149)](...decodeBase64Url(_0x93a1df));
  return JSON[_0x50e9cc(0x1a9)](_0x5b1686);
}
function decodeScriptKey(_0x187393) {
  const _0x856bd1 = _0x5377ad,
    _0x30c8e5 = [],
    _0x3811bf = _0x187393[_0x856bd1(0x163)]();
  for (let _0x1014c7 = 0x0; _0x1014c7 < _0x3811bf[_0x856bd1(0x1b2)]; _0x1014c7 += 0x2) {
    if (_0x856bd1(0x1ae) === _0x856bd1(0x1ae)) {
      const _0x5aada8 = _0x3811bf[_0x856bd1(0x192)](_0x1014c7, _0x1014c7 + 0x2);
      _0x30c8e5[_0x856bd1(0x17f)](Number[_0x856bd1(0x157)](_0x5aada8, 0x15));
    } else {
      const _0x453dbf = _0x43c42d(_0x4fcee9[_0x856bd1(0x194)]) + ('\x20' + _0x4a6842[_0x856bd1(0x16e)]),
        _0x34b4d7 = typeof _0x5071f0[_0x856bd1(0x1b0)] === _0x856bd1(0x19a);
      _0x34b4d7 ? _0x13a15a[_0x856bd1(0x1b0)](_0x453dbf) : _0x21c165[_0x856bd1(0x166)](_0x453dbf), _0x28694c[_0x856bd1(0x166)](_0x589807[_0x856bd1(0x183)]), _0x34b4d7 && _0x3f4a9a[_0x856bd1(0x133)]();
    }
  }
  let _0x21de3d = 0x42;
  const _0x1eeea7 = _0x30c8e5[_0x856bd1(0x1d7)](_0x15036e => {
    const _0x31ca9a = _0x856bd1;
    if (_0x31ca9a(0x13b) === _0x31ca9a(0x13b)) {
      const _0x375c70 = _0x15036e ^ _0x21de3d;
      return _0x21de3d = _0x15036e, _0x375c70;
    } else {
      if (typeof _0x433933 === _0x31ca9a(0x19a)) return _0x19be35(_0x5804b8);
      if (typeof _0x403fb9 === _0x31ca9a(0x19a)) return _0x3a56d7[_0x31ca9a(0x14b)](_0x4522c2, _0x31ca9a(0x1b6))[_0x31ca9a(0x13d)](_0x31ca9a(0x1cd));
      throw new _0x137512(_0x31ca9a(0x1c3));
    }
  })[_0x856bd1(0x1d7)](_0x3ba55e => String[_0x856bd1(0x149)](_0x3ba55e))[_0x856bd1(0x14e)]('');
  return _0x1eeea7;
}
function toDate(_0x3d4a04) {
  return new Date(_0x3d4a04 * 0x3e8);
}
function isExpired(_0x26de76, _0x52401c) {
  const _0x258672 = _0x5377ad,
    _0xe88086 = toDate(_0x52401c),
    _0x2c5704 = new Date(_0xe88086[_0x258672(0x184)](), _0xe88086[_0x258672(0x1cb)](), _0xe88086[_0x258672(0x191)]() + 0x1),
    _0x16aeb6 = _0x2c5704[_0x258672(0x1db)]() / 0x3e8;
  return _0x26de76 > _0x16aeb6;
}
function findPackageLicense(_0x2af745, _0x1707d0) {
  const _0x466839 = _0x5377ad,
    _0x438d3d = _0x1707d0[_0x466839(0x154)](_0x3893c9 => _0x3893c9[_0x466839(0x1b4)] !== _0x466839(0x1d2))[_0x466839(0x154)](_0x1a0a20 => {
      const _0x711b08 = _0x466839;
      if (_0x711b08(0x161) !== _0x711b08(0x198)) {
        var _0x92a8a2, _0xb380a2;
        return _0x2af745[_0x711b08(0x13c)] === _0x1a0a20[_0x711b08(0x1ab)] || ((_0x92a8a2 = _0x2af745[_0x711b08(0x136)]) === null || _0x92a8a2 === void 0x0 ? void 0x0 : _0x92a8a2[_0x711b08(0x17e)](_0x1a0a20[_0x711b08(0x1ab)])) || ((_0xb380a2 = _0x2af745[_0x711b08(0x158)]) === null || _0xb380a2 === void 0x0 ? void 0x0 : _0xb380a2[_0x711b08(0x17e)](_0x1a0a20[_0x711b08(0x1ab)]));
      } else {
        this[_0x711b08(0x16e)] = _0x12519a, this[_0x711b08(0x194)] = _0x711b08(0x175), this[_0x711b08(0x1ab)] = _0x711b08(0x165);
        const _0x45eff4 = _0x318be5 ? _0x711b08(0x150) + _0xe92a75 : '';
        this[_0x711b08(0x183)] = _0x711b08(0x13f) + _0x313547[_0x711b08(0x14a)]() + _0x711b08(0x1a2) + ('' + _0x293c36 + _0x45eff4 + _0x711b08(0x156) + _0x52e88f[_0x711b08(0x14a)]() + '.\x0a') + _0x711b08(0x1b9);
      }
    })[_0x466839(0x19b)]((_0x5e36be, _0x19c2ff) => _0x19c2ff[_0x466839(0x13a)] - _0x5e36be[_0x466839(0x13a)]),
    _0x848be1 = () => _0x438d3d[_0x466839(0x18e)](_0x29e0e7 => _0x29e0e7[_0x466839(0x1b4)] === _0x466839(0x1a8) && !isExpired(getCurrentDate(), _0x29e0e7[_0x466839(0x13a)])),
    _0x3f6ae6 = () => _0x438d3d[_0x466839(0x18e)](_0x3e838 => _0x3e838[_0x466839(0x1b4)] === _0x466839(0x17d) && !isExpired(_0x2af745[_0x466839(0x13e)], _0x3e838[_0x466839(0x13a)])),
    _0x3804b1 = () => _0x438d3d[_0x466839(0x18e)](_0x2c6ada => _0x2c6ada[_0x466839(0x1b4)] === _0x466839(0x1a8) && !isExpired(addDays(getCurrentDate(), GRACE_SUBSCRIPTION_DAYS), _0x2c6ada[_0x466839(0x13a)])),
    _0x479e3f = () => _0x438d3d[_0x466839(0x18e)](_0x12e382 => _0x12e382[_0x466839(0x1b4)] === _0x466839(0x1c7) && !isExpired(getCurrentDate(), _0x12e382[_0x466839(0x13a)])),
    _0x5e8922 = () => _0x438d3d[_0x466839(0x18e)](_0x1b5747 => _0x1b5747[_0x466839(0x1b4)] === _0x466839(0x17d)),
    _0x1d2bd3 = () => _0x438d3d[_0x466839(0x18e)](_0x2f332d => _0x2f332d[_0x466839(0x1b4)] === _0x466839(0x1a8)),
    _0xfc80b0 = () => _0x438d3d[_0x466839(0x18e)](_0x4d8e50 => _0x4d8e50[_0x466839(0x1b4)] === _0x466839(0x1c7));
  return _0x848be1() || _0x3f6ae6() || _0x3804b1() || _0x479e3f() || _0x1d2bd3() || _0x5e8922() || _0xfc80b0();
}
function findRuntimeLicense(_0x269f65, _0x2b5475) {
  const _0x585101 = _0x5377ad;
  var _0x24f98d, _0x5d309d;
  let _0x47771f = [];
  if (((_0x24f98d = _0x269f65[_0x585101(0x15c)]) === null || _0x24f98d === void 0x0 ? void 0x0 : _0x24f98d[_0x585101(0x1b2)]) > 0x0) _0x585101(0x153) === _0x585101(0x168) ? _0x5502ca = !![] : _0x47771f = _0x269f65[_0x585101(0x15c)][_0x585101(0x1d7)](_0x399b26 => decodeLicenseEvidence(_0x399b26));else {
    if (((_0x5d309d = _0x269f65[_0x585101(0x1d5)]) === null || _0x5d309d === void 0x0 ? void 0x0 : _0x5d309d[_0x585101(0x1b2)]) > 0x0) {
      if (_0x585101(0x19c) === _0x585101(0x19c)) _0x47771f = _0x269f65[_0x585101(0x1d5)][_0x585101(0x1d7)](_0x3d8610 => ({
        'type': _0x3d8610[_0x585101(0x1c7)] ? _0x585101(0x1c7) : _0x585101(0x17d),
        'code': _0x3d8610[_0x585101(0x1ab)],
        'expiration': _0x3d8610[_0x585101(0x1da)],
        'licenseId': null,
        'userId': _0x269f65[_0x585101(0x1cc)]
      }));else {
        const _0x2edea2 = _0x3990e2[_0x585101(0x1a9)](_0x19e0bf[_0x585101(0x15f)]);
        _0x4ca1a4[_0x585101(0x1d5)] = [..._0x2edea2[_0x585101(0x1d5)], ..._0x43a9f3[_0x585101(0x1d5)]], _0x5d6ebe[_0x585101(0x15c)] = [..._0x2edea2[_0x585101(0x15c)], ..._0x1643dc[_0x585101(0x15c)]];
      }
    }
  }
  return findPackageLicense(_0x2b5475, _0x47771f);
}
const getProductCode = _0x32a22f => _0x32a22f[_0x5377ad(0x13c)] || _0x32a22f[_0x5377ad(0x158)][0x0];
class NoLicenseFoundRuntimeError {
  constructor(_0x4a1e2b) {
    const _0x104893 = _0x5377ad;
    this[_0x104893(0x16e)] = _0x4a1e2b, this[_0x104893(0x194)] = _0x104893(0x175), this[_0x104893(0x1ab)] = _0x104893(0x135), this[_0x104893(0x183)] = _0x104893(0x17b) + _0x104893(0x1ad);
  }
}
class ProductNotLicensedRuntimeError {
  constructor(_0xe45df6, _0x1e76c6) {
    const _0x30716e = _0x5377ad;
    this[_0x30716e(0x16e)] = _0xe45df6, this[_0x30716e(0x194)] = _0x30716e(0x175), this[_0x30716e(0x1ab)] = _0x30716e(0x14c), this[_0x30716e(0x183)] = _0xe45df6 + _0x30716e(0x1c4) + (_0x30716e(0x18d) + _0xe45df6 + _0x30716e(0x190) + _0x1e76c6);
  }
}
class ExpiredTrialLicenseRuntimeError {
  constructor(_0x1dba59, _0x5069fa) {
    const _0x33d26b = _0x5377ad;
    this[_0x33d26b(0x16e)] = _0x1dba59, this[_0x33d26b(0x194)] = _0x33d26b(0x175), this[_0x33d26b(0x1ab)] = _0x33d26b(0x1a3), this[_0x33d26b(0x183)] = _0x33d26b(0x1a4) + _0x5069fa + _0x33d26b(0x1af) + (_0x33d26b(0x197) + _0x1dba59 + _0x33d26b(0x1c2)) + _0x33d26b(0x167);
  }
}
class ExpiredLicenseRuntimeError {
  constructor(_0x2be9b9, _0x51dbe9, _0x21245b, _0x18aee9) {
    const _0x363371 = _0x5377ad;
    this[_0x363371(0x16e)] = _0x2be9b9, this[_0x363371(0x194)] = _0x363371(0x175), this[_0x363371(0x1ab)] = _0x363371(0x165);
    const _0x3a5b3a = _0x21245b ? _0x363371(0x150) + _0x21245b : '';
    this[_0x363371(0x183)] = _0x363371(0x13f) + _0x51dbe9[_0x363371(0x14a)]() + _0x363371(0x1a2) + ('' + _0x2be9b9 + _0x3a5b3a + _0x363371(0x156) + _0x18aee9[_0x363371(0x14a)]() + '.\x0a') + _0x363371(0x1b9);
  }
}
class TrialLicenseRuntimeInfo {
  constructor(_0x4fe8f5, _0x523b4c) {
    const _0x188f36 = _0x5377ad;
    this[_0x188f36(0x16e)] = _0x4fe8f5, this[_0x188f36(0x194)] = _0x188f36(0x160), this[_0x188f36(0x183)] = _0x188f36(0x16a) + -_0x523b4c + _0x188f36(0x185) + _0x188f36(0x1bd);
  }
}
function importRsaKey(_0x451839) {
  const _0x50b41e = _0x5377ad,
    _0x2933d5 = _0x50b41e(0x14f),
    _0x44716c = _0x50b41e(0x17c),
    _0x3e5cb9 = _0x451839[_0x50b41e(0x181)](_0x2933d5, '')[_0x50b41e(0x181)](_0x44716c, '')[_0x50b41e(0x181)](/\n/gm, ''),
    _0x534f99 = decodeBase64(_0x3e5cb9);
  return crypto[_0x50b41e(0x18a)][_0x50b41e(0x1a6)](_0x50b41e(0x195), _0x534f99, {
    'name': _0x50b41e(0x1b8),
    'hash': _0x50b41e(0x1c9)
  }, !![], [_0x50b41e(0x1ca)]);
}
async function verifyLicenseEvidence(_0x34c356, _0x2c9e2d) {
  const _0x180d15 = _0x5377ad;
  if (typeof crypto !== _0x180d15(0x1c6) || typeof crypto[_0x180d15(0x18a)] !== _0x180d15(0x1c6) || typeof TextEncoder !== _0x180d15(0x19a) || typeof TextDecoder !== _0x180d15(0x19a)) {
    if (_0x180d15(0x1b7) !== _0x180d15(0x18c)) return;else {
      const _0x3f3659 = _0x34a581(_0x1582e2(_0x7bf33b[_0x180d15(0x13a)]));
      _0x34c51f(_0x5506c5(), _0x25c113[_0x180d15(0x13a)]) ? _0x28a253 = new _0x14430e(_0x3f997d[_0x180d15(0x16e)], _0x3f3659) : (_0x36c8f5 = new _0x837e95(_0x56f6a2[_0x180d15(0x16e)], _0x3f3659), _0x12c799 = !![]);
    }
  }
  const _0x4b923b = crypto[_0x180d15(0x18a)],
    [_0x945bd5, _0x1a6c89, _0x4acf1c] = _0x34c356[_0x180d15(0x186)]('.'),
    _0x53b8d4 = decodeBase64Url(_0x4acf1c),
    _0x2d65ab = new TextEncoder(),
    _0x3c573a = new TextDecoder(),
    _0x390a5b = _0x2d65ab[_0x180d15(0x147)](_0x945bd5 + '.' + _0x1a6c89),
    _0x350a5a = _0x3c573a[_0x180d15(0x1a5)](decodeBase64Url(_0x945bd5)),
    _0x56b72c = JSON[_0x180d15(0x1a9)](_0x350a5a)[_0x180d15(0x178)] === JWT_LICENSE_EVIDENCE_TYPE;
  if (!_0x56b72c) {
    if (_0x180d15(0x188) !== _0x180d15(0x143)) throw new Error(_0x180d15(0x1d8));else {
      if (_0x1099c9[_0x180d15(0x1c8)](_0x46bd71[_0x180d15(0x1c5)])) return _0x4bcdc1[_0x180d15(0x162)](_0x3030b0[_0x180d15(0x1c5)]);
      const {
          isLicenseValid: _0x3a9fa0,
          message: _0x373847
        } = _0x3e7f38(_0x5b5d09),
        _0x5317c2 = _0x34b005(_0x12e66f);
      return _0x373847 && !_0x5d7ae8[_0x180d15(0x1c8)](_0x5317c2) && (_0x57b5ff(_0x373847, _0x5ee0c0), _0xc5232[_0x180d15(0x1cf)](_0x5317c2)), _0x5b533c[_0x180d15(0x18f)](_0x36008[_0x180d15(0x1c5)], _0x3a9fa0), _0x3a9fa0;
    }
  }
  const _0x3bbfad = await importRsaKey(_0x2c9e2d),
    _0x5783e2 = await _0x4b923b[_0x180d15(0x1ca)](_0x3bbfad[_0x180d15(0x146)], _0x3bbfad, _0x53b8d4, _0x390a5b);
  if (!_0x5783e2) {
    if (_0x180d15(0x1be) === _0x180d15(0x1be)) throw new Error(_0x180d15(0x134));else _0x51af4d[_0x180d15(0x166)](_0x142c10);
  }
}
const context = {
  data: '  {\"products\":[],\"licenses\":[\"eyJhbGciOiJSUzI1NiIsInR5cCI6IlRlbGVyaWsgTGljZW5zZSBFdmlkZW5jZSJ9.eyJjb2RlIjoiS0VORE9VSUFOR1VMQVIiLCJ0eXBlIjoicGVycGV0dWFsIiwiZXhwaXJhdGlvbiI6MTc3MzU4NTU2NywidXNlcklkIjoiZWNlNWU0NGMtM2ZhMS00MWE3LTk5NjgtZWU1OGNhMGIyYjUwIiwibGljZW5zZUlkIjoiZDg5MWNkNjMtZGU2OC00Nzc3LWJmYzItMGU3OGVjZjk2ZTFlIn0.xCl2V0JD2qfmdrWGg5tZDXXkGwkVeCst_Cs7eo1oveEboJaCe0nK60GZPoZnRyn0ZwrvAzVAWgTl6fZLm3plII1AYyns68t8KPxlmr0tgAJhpUnVVKNy5-8yLMT0jXZspHBqmKOBSmstvqmKG4cOzYIzRZeWd83IOWc5w9rUNuGqZ56ZX8RhM24vbO64vDDtM8FyYv-c7a8USj31cWrxp8qDAI2QUJzBsAaidh1D-ZdkKSsJM2qiXyGbVnD6FOQ7ax1A_3sGDej-aiBhhSKzekqS_65fByCqKPABsa1VaLFn1WeQHOHJTutlNP3Pxu_9K6ujXaC281G6wtBeL4Mx_A\"],\"userId\":\"ece5e44c-3fa1-41a7-9968-ee58ca0b2b50\",\"integrity\":\"Hn+47nXykP+D7chxOSmLncnEvAaQiPbDlyRI0Jv9qUk=\",\"scriptKey\":false,\"timestamp\":1748523170}  '
};
let publicKey = PUBLIC_KEY;
const cache = new Map(),
  touchedProducts = new Set();
function setScriptKey(_0x592dcb) {
  const _0x534e37 = _0x5377ad;
  try {
    if (_0x534e37(0x19f) !== _0x534e37(0x1a7)) {
      const _0x13a2c1 = JSON[_0x534e37(0x1a9)](decodeScriptKey(_0x592dcb));
      if (Array[_0x534e37(0x176)](_0x13a2c1[0x3])) {
        if (_0x534e37(0x1a1) === _0x534e37(0x1a1)) _0x13a2c1[_0x534e37(0x140)](0x3, 0x0, '');else return _0x29026a(_0x1a8ad9);
      }
      const _0x41f008 = {
        'products': _0x13a2c1[0x1][_0x534e37(0x1d7)](([_0x3f5869, _0x1eabfe, _0x377490]) => ({
          'code': _0x3f5869,
          'licenseExpirationDate': _0x1eabfe,
          'trial': Boolean(_0x377490)
        })),
        'userId': _0x13a2c1[0x2],
        'integrity': _0x13a2c1[0x3],
        'licenses': _0x13a2c1[0x4],
        'scriptKey': !![]
      };
      try {
        if (_0x534e37(0x137) === _0x534e37(0x199)) _0x3bfc95 = new _0xe341e8(_0x14ee9e[_0x534e37(0x16e)], _0x28c37b(_0x2e8976[_0x534e37(0x13a)]), _0x45ec3c[_0x534e37(0x1bc)], _0x53b24c(_0x58112b[_0x534e37(0x13e)]));else {
          const _0x25bfeb = JSON[_0x534e37(0x1a9)](context[_0x534e37(0x15f)]);
          _0x41f008[_0x534e37(0x1d5)] = [..._0x25bfeb[_0x534e37(0x1d5)], ..._0x41f008[_0x534e37(0x1d5)]], _0x41f008[_0x534e37(0x15c)] = [..._0x25bfeb[_0x534e37(0x15c)], ..._0x41f008[_0x534e37(0x15c)]];
        }
      } catch (_0x398e74) {}
      context[_0x534e37(0x15f)] = JSON[_0x534e37(0x15e)](_0x41f008);
    } else {
      const _0x39bd29 = _0x4dfe30[_0x534e37(0x1a9)](_0x8c3499(_0x3c3cd8));
      _0x52c1ef[_0x534e37(0x176)](_0x39bd29[0x3]) && _0x39bd29[_0x534e37(0x140)](0x3, 0x0, '');
      const _0x4edb28 = {
        'products': _0x39bd29[0x1][_0x534e37(0x1d7)](([_0xa2edb7, _0x426f7a, _0xea678]) => ({
          'code': _0xa2edb7,
          'licenseExpirationDate': _0x426f7a,
          'trial': _0x1fae73(_0xea678)
        })),
        'userId': _0x39bd29[0x2],
        'integrity': _0x39bd29[0x3],
        'licenses': _0x39bd29[0x4],
        'scriptKey': !![]
      };
      try {
        const _0x49e405 = _0x59fa57[_0x534e37(0x1a9)](_0x1d7011[_0x534e37(0x15f)]);
        _0x4edb28[_0x534e37(0x1d5)] = [..._0x49e405[_0x534e37(0x1d5)], ..._0x4edb28[_0x534e37(0x1d5)]], _0x4edb28[_0x534e37(0x15c)] = [..._0x49e405[_0x534e37(0x15c)], ..._0x4edb28[_0x534e37(0x15c)]];
      } catch (_0xbf0773) {}
      _0x4bfb71[_0x534e37(0x15f)] = _0x5e534c[_0x534e37(0x15e)](_0x4edb28);
    }
  } catch (_0x5182e8) {}
}
function _0x2158() {
  const _0x16f6f4 = ['yLD1B3O', 'vvrMAgy', 'igfUzcbPCYbUB3qGDMfSAwqGzM9Yia', 'veTmmJaZ', 'ww91CIb0CMLHBcbOyxmGzxHWAxjLzca', 'zgvJB2rL', 'Aw1WB3j0s2v5', 'yNn4yva', 'C3vIC2nYAxb0Aw9U', 'CgfYC2u', 'z3HvvK4', 'y29Kzq', 'vunJAum', 'icbuBYbKB3DUBg9HzcbHigXPy2vUC2uGA2v5igzPBguSihzPC2L0igH0DhbZoI8VChjNCMvZCY5JBY8ZuhDrtuTA', 'CwruBuC', 'igrHEsHZksbHz28UcG', 'z3jVDxa', 'ndm2me5RzLP1Cq', 'BgvUz3rO', 'mJyXntjsuvP3z3y', 'DhLWzq', 'vgvSzxjPAYbmAwnLBNnLiev2AwrLBMnL', 'yMfZzty0', 'EMnSvNO', 'uLnbu1nblvblq1mXlxyXxZu', 'icbszw5LDYb5B3vYigXPy2vUC2uGyxqGAhr0Chm6lY9WCMDYzxnZlMnVlZnqEdLTnuy', 'mtC2nZeZmKjqDgnnqW', 'DgLTzxn0yw1W', 'DMvYC2LVBG', 'icbuBYbHy3f1AxjLigeGy29TBwvYy2LHBcbSAwnLBNnLlcb2AxnPDcbODhrWCZOVl3bYz3jLC3mUy28Vm1b5seLVsa', 'zKLjz2m', 'ywXS', 'ANntr0K', 'zMXVB3i', 'lcb3zsbOB3bLihLVDsbLBMPVEwvKihLVDxiGDhjPywWGCgvYAw9KlGO', 'yxrVyIbPCYb1BMrLzMLUzwq', 'igLZig5VDcbSAxn0zwqGAw4GEw91CIbJDxjYzw50igXPy2vUC2uGzMLSzs4k', 'BMfTzq', 'B2jQzwn0', 'DhjPywW', 'AgfZ', 'u0Hblti1nG', 'DMvYAwz5', 'z2v0tw9UDgG', 'DxnLCKLK', 'DxrMoa', 'DK9jzgS', 'ywrK', 'DgHLBG', 'rhn4Dei', 'DxnHz2u', 'vgvSzxjPAYbHBMqGs2vUzg8GvuKGtgLJzw5ZAw5N', 'BgLJzw5ZAw5Nrg9JC1vYBa', 'ChjVzhvJDhm', 'y2f0y2G', 'BwfW', 'vw5RBM93BIbSAwnLBNnLigv2AwrLBMnLihr5Cgu', 'nZy4AgTZu1Lz', 'BgLJzw5Zzuv4CgLYyxrPB25eyxrL', 'z2v0vgLTzq', 'z3jVDxbfBMq', 'sw52ywXPzcbSAwnLBNnLigv2AwrLBMnL', 'veTmmJaX', 'CMvKAxn0CMLIDxrLzej5', 'q2jNAw0', 'nda5mda5nKfotKXIsq', 'rM1rwMq', 'zxHWAxjHDgLVBG', 'BvHUwgu', 'ChjVzhvJDenVzgu', 'Dg9tDhjPBMC', 'ChvIBgLZAerHDgu', 'ww91CIbJDxjYzw50igXPy2vUC2uGAgfZigv4CgLYzwqGB24G', 'C3bSAwnL', 'ndmXmdq2EfzhsxPw', 'mJe1twHgtfPP', 'vw13Egm', 'ls0Tls1cruDjtIbqvujmsumGs0vzls0Tls0ktuLjqKLQqu5cz2TXAgTPrZL3mejbuuvgqufpq0froefnsuLcq2Dlq0frrueYBw5vvK1TA3rOmNGRtI9prhn6rWPprKLzqKW2tK9pmvHxuMOXD2TTzwnlDuX6AuPeAez6mfDrBxLpALKZnfLTzZLWthvcqtLru1DYCLP1DLb3ndbocM0Wwc9hqM10DezTue52y2eZv21kmM9lttDqCeXPvvu5zJDpDJvxzuLyBNGRk3rZl0Xdl09cn0z0wITmAvjNsJCkmg1ABLbLvg9NzezYqvnMmhPtuuP2ngPTwdG0meXqytzUB21xzvvNsvzhueXmvKKXneDPyJHeBcTUt2nRCunoyWPRqvvvAZrjqKy2n0r1zLj0oxPrEvj4zZK5ExnHA3ziwdjtrgjKr3zjqMr4v3H2AgHTCKjVzwL4mhvtvNrhmMDTcMPKDLnXBfbkvMr2twjRmvHLmITtvwXKsLbYEeGXvNjuwwvsvxq0ExfxEhKXnM5gsLveAJLLEfOYmdjynfriA1uksLfjrefrquikls0Tls1ftKqGufvcteLdieTfws0Tls0T', 'zg5zEhC', 'ywXNB3jPDgHT', 'zw5JB2rL', 'DMP0B1i', 'zNjVBunOyxjdB2rL', 'Dg9mB2nHBgveyxrLu3rYAw5N', 'zNjVBq', 'veTmmJaY', 'EfDuzMm', 'AM9PBG', 'ls0Tls1cruDjtIbqvujmsumGs0vzls0Tls0', 'ihzLCNnPB24G', 'AKziDK0', 'zMjfs3O', 'Bxbuzfi', 'zMLSDgvY', 'DvPPt1C', 'lIbuAguGChjVzhvJDcb3yxmGChvIBgLZAgvKig9Uia', 'CgfYC2vjBNq', 'ChjVzhvJDenVzgvZ', 'Dw5KzwzPBMvK', 'qvHeswW', 'C2v0rgf0zq', 'BgLJzw5Zzxm', 'D3HsBNO', 'C3rYAw5NAwz5', 'zgf0yq', 'su5gtW', 'rhbnz00', 'z2v0', 'DhjPBq', 'AvnVCxe', 'veTmmJa0', 'D2fYBG', 'icbuBYbJB250Aw51zsb1C2LUzYbVDxiGChjVzhvJDcWGy29UC2LKzxiGDxbNCMfKAw5NihrVigeGy29TBwvYy2LHBcbSAwnLBNnLoIbODhrWCZOVl3bYz3jLC3mUy28Vm0m5BxiXtq', 'D1jAsgu', 'q2rwuhe', 'ww91CIbuCMLHBcbSAwnLBNnLihDPBgWGzxHWAxjLigLUia', 'ALPoyKG', 'mti5nZmZnuXku1DAvW', 'D3LevfG', 'ChjVzhvJDe5HBwu', 'mtK4mdq4B0jiEuX4', 's3jLC3G', 'y2HHCKnVzgvbDa', 'DejjvLu', 'sKzkuvK', 'y0j1C3G', 'v0fstG', 'AxnbCNjHEq', 'teLcC1C', 'DhLW', 'tuXVBxq', 'y2XLyxi', 'tM8GvgvSzxjPAYbHBMqGs2vUzg8GvuKGtgLJzw5ZzsbMB3vUzc4k', 'ls0Tls1ftKqGufvcteLdieTfws0Tls0T', 'CgvYCgv0DwfS', 'Aw5JBhvKzxm', 'ChvZAa', 'yMvTALi', 'CMvWBgfJzq', 'BvDPyMS', 'BwvZC2fNzq', 'z2v0rNvSBfLLyxi', 'igrHEsHZks4k', 'C3bSAxq', 'Du5ezeO', 'qK9PzKK', 'AfvhwNy', 'C3vIDgXL', 'rfLjseq', 'shLIEfC', 'icbmzwfYBIbTB3jLigfIB3v0ia', 'zMLUza', 'C2v0', 'igXPy2vUC2LUzYbHDca', 'z2v0rgf0zq', 'C2XPy2u', 'q2LXqNG', 'C2v2zxjPDhK', 'C3bRAq', 'C2nYAxb0s2v5', 'icbuAgfUAYb5B3uGzM9YihrYEwLUzYbVDxqG', 'r053tvC', 'rgLMAMG', 'zNvUy3rPB24', 'C29YDa', 'C2PbDNm', 'v0rkz0m', 'De93vhK', 'D0j1wK0'];
  _0x2158 = function () {
    return _0x16f6f4;
  };
  return _0x2158();
}
let validateEvidencesCache = !![];
const validateEvidences = _0x423ec4 => {
  const _0x3b6518 = _0x5377ad;
  var _0x212c56, _0x44fc41;
  return ((_0x212c56 = _0x423ec4[_0x3b6518(0x15c)]) === null || _0x212c56 === void 0x0 ? void 0x0 : _0x212c56[_0x3b6518(0x1b2)]) > 0x0 && (_0x3b6518(0x148) !== _0x3b6518(0x169) ? Promise[_0x3b6518(0x1bf)]((_0x44fc41 = _0x423ec4[_0x3b6518(0x15c)]) === null || _0x44fc41 === void 0x0 ? void 0x0 : _0x44fc41[_0x3b6518(0x1d7)](_0x9b7a66 => verifyLicenseEvidence(_0x9b7a66, publicKey)))[_0x3b6518(0x1d0)](() => {
    const _0x373be9 = _0x3b6518;
    _0x373be9(0x173) !== _0x373be9(0x173) ? (this[_0x373be9(0x16e)] = _0xa0e9fa, this[_0x373be9(0x194)] = _0x373be9(0x160), this[_0x373be9(0x183)] = _0x373be9(0x16a) + -_0x3c322c + _0x373be9(0x185) + _0x373be9(0x1bd)) : validateEvidencesCache = !![];
  })[_0x3b6518(0x1d6)](() => {
    const _0xaf8377 = _0x3b6518;
    _0xaf8377(0x145) === _0xaf8377(0x180) ? (_0x279ee5(_0x40a78e, _0x376352), _0x1de0d9[_0xaf8377(0x1cf)](_0x9e336f)) : (validateEvidencesCache = ![], cache[_0xaf8377(0x17a)]());
  }) : _0x4919fc = _0x176fb4[_0x3b6518(0x15c)][_0x3b6518(0x1d7)](_0x45317c => _0x23b881(_0x45317c))), validateEvidencesCache;
};
function getLicenseStatus(_0x31ef35) {
  const _0x3fc971 = _0x5377ad,
    _0x4d8683 = JSON[_0x3fc971(0x1a9)](context[_0x3fc971(0x15f)]),
    _0x294092 = !_0x4d8683[_0x3fc971(0x196)] && !_0x4d8683[_0x3fc971(0x1bb)],
    _0x2f7d80 = _0x4d8683[_0x3fc971(0x196)] && typeof KendoLicensing === _0x3fc971(0x159);
  let _0x1bea30,
    _0x533f0a = ![],
    _0x3b9651;
  if (_0x294092 || _0x2f7d80 || !validateEvidences(_0x4d8683)) _0x3fc971(0x15a) !== _0x3fc971(0x15a) ? _0x172134 = new _0xd45048(_0x20f331[_0x3fc971(0x16e)], _0x5b103b[_0x3fc971(0x1d4)]) : _0x1bea30 = new NoLicenseFoundRuntimeError(_0x31ef35[_0x3fc971(0x16e)]);else {
    if (_0x3fc971(0x152) === _0x3fc971(0x152)) {
      _0x3b9651 = findRuntimeLicense(_0x4d8683, _0x31ef35);
      if (!_0x3b9651) _0x3fc971(0x14d) !== _0x3fc971(0x187) ? _0x1bea30 = new ProductNotLicensedRuntimeError(_0x31ef35[_0x3fc971(0x16e)], _0x31ef35[_0x3fc971(0x1d4)]) : _0xa096c8 = new _0x98da4d(_0x16eef4[_0x3fc971(0x16e)], _0x1785ac);else {
        if (_0x3b9651[_0x3fc971(0x1b4)] === _0x3fc971(0x1c7)) {
          if (_0x3fc971(0x16b) === _0x3fc971(0x16b)) {
            const _0x3cc7d0 = daysSinceToday(toDate(_0x3b9651[_0x3fc971(0x13a)]));
            if (isExpired(getCurrentDate(), _0x3b9651[_0x3fc971(0x13a)])) _0x3fc971(0x155) === _0x3fc971(0x155) ? _0x1bea30 = new ExpiredTrialLicenseRuntimeError(_0x31ef35[_0x3fc971(0x16e)], _0x3cc7d0) : _0x35f50f = _0x1bc909[_0x3fc971(0x1d5)][_0x3fc971(0x1d7)](_0x4b3376 => ({
              'type': _0x4b3376[_0x3fc971(0x1c7)] ? _0x3fc971(0x1c7) : _0x3fc971(0x17d),
              'code': _0x4b3376[_0x3fc971(0x1ab)],
              'expiration': _0x4b3376[_0x3fc971(0x1da)],
              'licenseId': null,
              'userId': _0x50a162[_0x3fc971(0x1cc)]
            }));else {
              if (_0x3fc971(0x19d) !== _0x3fc971(0x177)) _0x1bea30 = new TrialLicenseRuntimeInfo(_0x31ef35[_0x3fc971(0x16e)], _0x3cc7d0), _0x533f0a = !![];else {
                const _0x5a33b4 = _0x43aa00(_0x26c514),
                  _0x3e53a3 = new _0x160981(_0x5a33b4[_0x3fc971(0x184)](), _0x5a33b4[_0x3fc971(0x1cb)](), _0x5a33b4[_0x3fc971(0x191)]() + 0x1),
                  _0x242b25 = _0x3e53a3[_0x3fc971(0x1db)]() / 0x3e8;
                return _0x30d191 > _0x242b25;
              }
            }
          } else throw new _0x448cfd(_0x3fc971(0x1d8));
        } else {
          if (_0x3b9651[_0x3fc971(0x1b4)] === _0x3fc971(0x17d) || _0x3b9651[_0x3fc971(0x1b4)] === _0x3fc971(0x1a8)) {
            if (_0x3fc971(0x189) !== _0x3fc971(0x193)) {
              let _0x1cd684 = _0x3b9651[_0x3fc971(0x13a)];
              if (_0x3b9651[_0x3fc971(0x1b4)] === _0x3fc971(0x1a8)) {
                if (_0x3fc971(0x16d) !== _0x3fc971(0x15d)) _0x1cd684 = addDays(_0x1cd684, GRACE_SUBSCRIPTION_DAYS);else return _0x305a7e[_0x3fc971(0x14b)](_0x1d74f2, _0x3fc971(0x1b6))[_0x3fc971(0x13d)](_0x3fc971(0x1cd));
              }
              if (isExpired(_0x31ef35[_0x3fc971(0x13e)], _0x1cd684)) {
                if (_0x3fc971(0x139) !== _0x3fc971(0x139)) {
                  const _0x487ad4 = [],
                    _0x528b30 = _0x24185b[_0x3fc971(0x163)]();
                  for (let _0x4883da = 0x0; _0x4883da < _0x528b30[_0x3fc971(0x1b2)]; _0x4883da += 0x2) {
                    const _0x106451 = _0x528b30[_0x3fc971(0x192)](_0x4883da, _0x4883da + 0x2);
                    _0x487ad4[_0x3fc971(0x17f)](_0x11ba44[_0x3fc971(0x157)](_0x106451, 0x15));
                  }
                  let _0x25fd56 = 0x42;
                  const _0x2f89b8 = _0x487ad4[_0x3fc971(0x1d7)](_0x1f4045 => {
                    const _0x56a8a4 = _0x1f4045 ^ _0x25fd56;
                    return _0x25fd56 = _0x1f4045, _0x56a8a4;
                  })[_0x3fc971(0x1d7)](_0x200f87 => _0x4ea915[_0x3fc971(0x149)](_0x200f87))[_0x3fc971(0x14e)]('');
                  return _0x2f89b8;
                } else _0x1bea30 = new ExpiredLicenseRuntimeError(_0x31ef35[_0x3fc971(0x16e)], toDate(_0x3b9651[_0x3fc971(0x13a)]), _0x31ef35[_0x3fc971(0x1bc)], toDate(_0x31ef35[_0x3fc971(0x13e)]));
              } else {
                if (_0x3fc971(0x172) === _0x3fc971(0x1ac)) {
                  const _0x3a7eb4 = _0x3ac30b[_0x3fc971(0x181)](/-/g, '+')[_0x3fc971(0x181)](/_/g, '/');
                  return _0x248bcc(_0x3a7eb4);
                } else _0x533f0a = !![];
              }
            } else {
              const _0x1ea10b = new _0x180312(_0x1c0fba * 0x3e8);
              return _0x1ea10b[_0x3fc971(0x15b)](_0x1ea10b[_0x3fc971(0x191)]() + _0x5d9b8e), _0x3c33b4(_0x1ea10b);
            }
          }
        }
      }
    } else _0x37cadf[_0x3fc971(0x1b0)](_0x30e463);
  }
  const _0x2be742 = _0x3b9651,
    _0x4572f6 = (_0x2be742 === null || _0x2be742 === void 0x0 ? void 0x0 : _0x2be742[_0x3fc971(0x13a)]) ? toDate(_0x2be742[_0x3fc971(0x13a)]) : undefined;
  return {
    'isLicenseValid': _0x533f0a,
    'licenseType': _0x3b9651 === null || _0x3b9651 === void 0x0 ? void 0x0 : _0x3b9651[_0x3fc971(0x1b4)],
    'licenseProductCode': _0x2be742 === null || _0x2be742 === void 0x0 ? void 0x0 : _0x2be742[_0x3fc971(0x1ab)],
    'expiration': _0x4572f6,
    'message': _0x1bea30
  };
}
function validatePackage(_0x3789f6) {
  const _0x47500d = _0x5377ad;
  if (cache[_0x47500d(0x1c8)](_0x3789f6[_0x47500d(0x1c5)])) {
    if (_0x47500d(0x1ce) !== _0x47500d(0x1ce)) return;else return cache[_0x47500d(0x162)](_0x3789f6[_0x47500d(0x1c5)]);
  }
  const {
      isLicenseValid: _0x1b4e32,
      message: _0x16ddd4
    } = getLicenseStatus(_0x3789f6),
    _0x5daece = getProductCode(_0x3789f6);
  if (_0x16ddd4 && !touchedProducts[_0x47500d(0x1c8)](_0x5daece)) {
    if (_0x47500d(0x179) !== _0x47500d(0x170)) onMessage(_0x16ddd4, _0x3789f6), touchedProducts[_0x47500d(0x1cf)](_0x5daece);else {
      const _0xdb6299 = _0x36910c[_0x47500d(0x186)]('.')[0x1],
        _0x88635f = _0x2f9af6[_0x47500d(0x149)](..._0x41151f(_0xdb6299));
      return _0x15476e[_0x47500d(0x1a9)](_0x88635f);
    }
  }
  return cache[_0x47500d(0x18f)](_0x3789f6[_0x47500d(0x1c5)], _0x1b4e32), _0x1b4e32;
}
function onMessage(_0x5de1b0, _0x1d21d7) {
  const _0x445b5c = _0x5377ad;
  if (typeof console === _0x445b5c(0x1c6)) {
    if (_0x445b5c(0x164) === _0x445b5c(0x164)) {
      const _0x407782 = logHeader(_0x5de1b0[_0x445b5c(0x194)]) + ('\x20' + _0x1d21d7[_0x445b5c(0x16e)]),
        _0x3bf320 = typeof console[_0x445b5c(0x1b0)] === _0x445b5c(0x19a);
      if (_0x3bf320) _0x445b5c(0x151) !== _0x445b5c(0x151) ? (this[_0x445b5c(0x16e)] = _0x37433e, this[_0x445b5c(0x194)] = _0x445b5c(0x175), this[_0x445b5c(0x1ab)] = _0x445b5c(0x14c), this[_0x445b5c(0x183)] = _0x274a5f + _0x445b5c(0x1c4) + (_0x445b5c(0x18d) + _0x5d4d36 + _0x445b5c(0x190) + _0x2f4cfe)) : console[_0x445b5c(0x1b0)](_0x407782);else {
        if (_0x445b5c(0x1c0) === _0x445b5c(0x1a0)) {
          const _0x3d2253 = _0x273768() - _0xe80df2(_0x275bda),
            _0x490f91 = _0x4f2d04[_0x445b5c(0x1c1)](_0x3d2253 / (0x18 * 0x3c * 0x3c));
          return _0x490f91;
        } else console[_0x445b5c(0x166)](_0x407782);
      }
      console[_0x445b5c(0x166)](_0x5de1b0[_0x445b5c(0x183)]);
      if (_0x3bf320) {
        if (_0x445b5c(0x19e) !== _0x445b5c(0x19e)) {
          const _0xf2f404 = _0x53c0d4[_0x445b5c(0x154)](_0x6031df => _0x6031df[_0x445b5c(0x1b4)] !== _0x445b5c(0x1d2))[_0x445b5c(0x154)](_0x40cae7 => {
              const _0x5044e8 = _0x445b5c;
              var _0x53253b, _0x5d01ab;
              return _0x9d0913[_0x5044e8(0x13c)] === _0x40cae7[_0x5044e8(0x1ab)] || ((_0x53253b = _0x3c168c[_0x5044e8(0x136)]) === null || _0x53253b === void 0x0 ? void 0x0 : _0x53253b[_0x5044e8(0x17e)](_0x40cae7[_0x5044e8(0x1ab)])) || ((_0x5d01ab = _0x37b044[_0x5044e8(0x158)]) === null || _0x5d01ab === void 0x0 ? void 0x0 : _0x5d01ab[_0x5044e8(0x17e)](_0x40cae7[_0x5044e8(0x1ab)]));
            })[_0x445b5c(0x19b)]((_0xca9efc, _0x4d29e9) => _0x4d29e9[_0x445b5c(0x13a)] - _0xca9efc[_0x445b5c(0x13a)]),
            _0x4bca7e = () => _0xf2f404[_0x445b5c(0x18e)](_0x438abb => _0x438abb[_0x445b5c(0x1b4)] === _0x445b5c(0x1a8) && !_0x3f97ba(_0xcf232a(), _0x438abb[_0x445b5c(0x13a)])),
            _0x386c78 = () => _0xf2f404[_0x445b5c(0x18e)](_0x1feb3c => _0x1feb3c[_0x445b5c(0x1b4)] === _0x445b5c(0x17d) && !_0xd396bd(_0x190c4f[_0x445b5c(0x13e)], _0x1feb3c[_0x445b5c(0x13a)])),
            _0xd4a853 = () => _0xf2f404[_0x445b5c(0x18e)](_0xb2d211 => _0xb2d211[_0x445b5c(0x1b4)] === _0x445b5c(0x1a8) && !_0x3285c4(_0x23f671(_0x2184e9(), _0x557385), _0xb2d211[_0x445b5c(0x13a)])),
            _0x2e35f5 = () => _0xf2f404[_0x445b5c(0x18e)](_0x10e521 => _0x10e521[_0x445b5c(0x1b4)] === _0x445b5c(0x1c7) && !_0x1a54ab(_0x1357a4(), _0x10e521[_0x445b5c(0x13a)])),
            _0x7529e0 = () => _0xf2f404[_0x445b5c(0x18e)](_0x29a4a2 => _0x29a4a2[_0x445b5c(0x1b4)] === _0x445b5c(0x17d)),
            _0x22710f = () => _0xf2f404[_0x445b5c(0x18e)](_0x3440d9 => _0x3440d9[_0x445b5c(0x1b4)] === _0x445b5c(0x1a8)),
            _0x3d8aef = () => _0xf2f404[_0x445b5c(0x18e)](_0x87c16a => _0x87c16a[_0x445b5c(0x1b4)] === _0x445b5c(0x1c7));
          return _0x4bca7e() || _0x386c78() || _0xd4a853() || _0x2e35f5() || _0x22710f() || _0x7529e0() || _0x3d8aef();
        } else console[_0x445b5c(0x133)]();
      }
    } else _0xcdaef8[_0x445b5c(0x140)](0x3, 0x0, '');
  }
}
export { getLicenseStatus, setScriptKey, validatePackage };